module.exports = require('./bundle').traverse()
